import { zoneColors } from 'pages/Device/ThermostatRthPanel/Chart/chartOptions'

const parseLegendData = (allTraces, rthData) => {
  return {
    zones: parseZonesLegendData(allTraces, rthData),
    allSeries: allTraces,
    isControlHub: rthData.isControlHub
  }
}

// checks occurrences data is not empty
const isLegendItemHasData = (legendItem, legendData) => {
  return _.any(legendData.allSeries, (series) => (series && series.seriesName === legendItem.seriesName && series.x.length > 0 && _.any(series.y, (value) => !!value)))
}

const parseZonesLegendData = (allTraces, rthData) => {
  return rthData.zones.map((zone, index) => {
    const zoneTraces = _.filter(allTraces, (trace) => trace.group === zone.name)

    return {
      name: zone.name,
      color: zoneColors[index],
      zoneItems: zoneTraces.map((trace) => {
        return {
          seriesName: trace.seriesName,
          emptyDataSet: trace.x.length === 0
        }
      })
    }
  })
}

const alertsWithinVisibleRange = (layout, alerts) => {
  const minTime = new Date(layout.xaxis.range[0]).getTime()
  const maxTime = new Date(layout.xaxis.range[1]).getTime()

  return _.chain(alerts || [])
    .filter(({ occurredAt }) => {
      const time = new Date(occurredAt).getTime()

      return (time >= minTime) &&
        (time <= maxTime)
    })
    .sortBy(({ occurredAt }) => new Date(occurredAt).getTime())
    .value()
}

const legendDataParser = {
  parseLegendData,
  isLegendItemHasData,
  alertsWithinVisibleRange
}

export default legendDataParser
